/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `0` - off
 * * `1` - max between avg and divided channel based friction
 * * `2` - always linearized
 * * `3` - linearizes the depth based on a weighed averaged
 * @export
 */
export const FrictionShallowWaterDepthCorrectionEnum = {
  OFF: 0,
  MAX_BETWEEN_AVG_AND_DIVIDED_CHANNEL_BASED_FRICTION: 1,
  ALWAYS_LINEARIZED: 2,
  LINEARIZES_THE_DEPTH_BASED_ON_A_WEIGHED_AVERAGED: 3,
} as const;
export type FrictionShallowWaterDepthCorrectionEnum =
  (typeof FrictionShallowWaterDepthCorrectionEnum)[keyof typeof FrictionShallowWaterDepthCorrectionEnum];

export function instanceOfFrictionShallowWaterDepthCorrectionEnum(value: any): boolean {
  for (const key in FrictionShallowWaterDepthCorrectionEnum) {
    if (Object.prototype.hasOwnProperty.call(FrictionShallowWaterDepthCorrectionEnum, key)) {
      if (
        FrictionShallowWaterDepthCorrectionEnum[
          key as keyof typeof FrictionShallowWaterDepthCorrectionEnum
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function FrictionShallowWaterDepthCorrectionEnumFromJSON(
  json: any
): FrictionShallowWaterDepthCorrectionEnum {
  return FrictionShallowWaterDepthCorrectionEnumFromJSONTyped(json, false);
}

export function FrictionShallowWaterDepthCorrectionEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FrictionShallowWaterDepthCorrectionEnum {
  return json as FrictionShallowWaterDepthCorrectionEnum;
}

export function FrictionShallowWaterDepthCorrectionEnumToJSON(
  value?: FrictionShallowWaterDepthCorrectionEnum | null
): any {
  return value as any;
}

export function FrictionShallowWaterDepthCorrectionEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): FrictionShallowWaterDepthCorrectionEnum {
  return value as FrictionShallowWaterDepthCorrectionEnum;
}
